'use strict';

var d3 = require('d3');

/**
 * Color Scales
 *
 * A set of color scales used across all charts
 *
 * @constructor
 */
var ColorScales = function ColorScales() {
  var colorSet10 = ['#CC7025', '#074849', '#53335E', '#1A4D66', '#2E3D10', '#FFC694', '#099C9D', '#D0ABDE', '#79CAF2', '#729135'];
  var colorSet20 = ['#1f77b4', '#aec7e8', '#ff7f0e', '#ffbb78', '#2ca02c', '#98df8a', '#d62728', '#ff9896', '#9767bd', '#c5b0d5', '#8c564b', '#c49c94', '#e377c2', '#f7b6d2', '#7f7f7f', '#c7c7c7', '#bcbd22', '#dbdb8d', '#17becf', '#9edae5'];
  var colorSetBlank20 = ['#b6d3e7', '#e5edf7', '#ffd6b2', '#ffe9d4', '#b9e0bb', '#def5da', '#f2b8b8', '#ffdede', '#ddceea', '#ede6f1', '#dac8c4', '#ecdfdd', '#f6d4eb', '#fce8f1', '#d6d6d6', '#ededed', '#e9eab9', '#f3f3db', '#b2eaf0', '#e0f3f7'];
  var colorSet26a = ['#0F64A9', '#1368A5', '#166CA0', '#1A709C', '#1E7597', '#217993', '#257D8E', '#29818A', '#2C8585', '#308981', '#328B7F', '#338D7D', '#358F7B', '#379179', '#389377', '#3A9575', '#3A9671', '#3B9674', '#3E9A6F', '#429E6B', '#46A266', '#49A662', '#4DAB5D', '#51AF59', '#54B354', '#58B750'];
  var colorSet26b = ['#864123', '#8B4823', '#904F23', '#955623', '#9A5C22', '#A46A22', '#A97122', '#AE7822', '#B37F22', '#B88622', '#BF8F21', '#C29221', '#C49521', '#C69821', '#C89C21', '#CDA221', '#CFA521', '#D1A821', '#D4AB20', '#DAB420', '#DCB720', '#DFBA20', '#E1BE20', '#E3C120', '#E8C720', '#EACA20'];
  function createScale(scaleData) {
    return d3.scale.ordinal().domain(d3.range(1, scaleData.length)).range(scaleData);
  }
  var _colorScale = createScale(colorSet10);
  var _colorScale2 = createScale(colorSet20);
  var _colorScaleBlank = createScale(colorSetBlank20);
  var _colorScale26a = createScale(colorSet26a);
  var _colorScale26b = createScale(colorSet26b);
  return {
    colorScale1: function colorScale1() {
      return _colorScale;
    },
    colorScale20: function colorScale20() {
      return _colorScale2;
    },
    colorScaleBlank20: function colorScaleBlank20() {
      return _colorScaleBlank;
    },
    colorScale26a: function colorScale26a() {
      return _colorScale26a;
    },
    colorScale26b: function colorScale26b() {
      return _colorScale26b;
    }
  };
};
ColorScales.$inject = [];
module.exports = ColorScales;